import { render, staticRenderFns } from "./OButtonBar.vue?vue&type=template&id=20d02a74"
import script from "./OButtonBar.vue?vue&type=script&lang=js"
export * from "./OButtonBar.vue?vue&type=script&lang=js"
import style0 from "./OButtonBar.vue?vue&type=style&index=0&id=20d02a74&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports